import styled from "styled-components";

export const Titulo = styled.h2`
    margin-top: 40px;
    margin-bottom: 25px;
    text-align: center;
    color: #EDC0C3;
`
export const Botoes = styled.div`
    margin-top: 30px;
`